import debounce from 'debounce'
import mitt from 'mitt'
import { onUnmounted } from 'vue'

/*
    A wrapper around the mitt npm package to create a signature that
    matches the syntax of the old EventBus vue2 class so we can have
    an drop-in replacement.

    TODO: at some point we should remove this and just use mitt directly
*/
class Bus {
	constructor() {
		this._emitter = mitt()
		this._debouncers = {}
	}

	$on(eventName, handler) {
		if (!eventName) return
		if (Array.isArray(eventName)) {
			eventName.forEach((eName) => {
				this._emitter.on(eName, handler)
			})
		} else {
			this._emitter.on(eventName, handler)
		}
		this._events = Object.fromEntries(this._emitter.all)
		return () => this.$off(eventName, handler)
	}

	$off(eventName, handler) {
		if (!eventName) return
		if (Array.isArray(eventName)) {
			eventName.forEach((eName) => {
				this._emitter.off(eName, handler)
			})
		} else {
			this._emitter.off(eventName, handler)
		}
		this._events = Object.fromEntries(this._emitter.all)
	}

	$emit(eventName, data) {
		this._emitter.emit(eventName, data)
		this._events = Object.fromEntries(this._emitter.all)
	}

	$emitDebounced(eventName, data, delayMS = 5) {
		const key = `${eventName}-${delayMS}ms`
		this._debouncers[key] =
			this._debouncers[key] || debounce(this.$emit.bind(this), delayMS)
		this._debouncers[key](eventName, data)
	}
}

const bus = new Bus()

export default bus

export { Bus }

export function useEventBus(eventName, callback) {
	if (eventName && callback) {
		const off = bus.$on(eventName, callback)
		onUnmounted(() => off())
	}
	return bus
}
